<template>
    <div class="device-rating-reviews">
        <div class="h4 mb-1 pb-0">
            {{ title }}
        </div>
        <div class="ob1-rating" :style="ob1RatingStyle">
            <span class="ob1-stars" :data-rating="roundedAverage" aria-hidden="true" />
            <span class="ob1-score ps-1"><span class="visually-hidden">Note </span><span class="h1">{{ formattedAverage }}</span><span
                class="ob1-score-max ps-0"
            >/5</span><span class="ob1-rating-label ps-1">{{ text }}</span></span>
        </div>
        <ob1-liens-icone
            :title="linkLabel"
            :href="linkUrl"
            icon="icon-info-alt"
            :mini="true"
            target="_blank"
        />
    </div>
</template>

<script>
export default {
    name: "DeviceRatingReviews",
    props: {
        average: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            required: false,
            default: ""
        },
        // taille de police en rem
        ratingResultsHeight: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true,
        },
        linkLabel: {
            type: String,
            required: true,
        },
        linkUrl: {
            type: String,
            required: true,
        }
    },
    computed: {
        roundedAverage() {
            if (Math.round(this.average) === this.average) {
                return this.average
            }
            return this.average.toFixed(1)
        },
        formattedAverage() {
            return this.roundedAverage.toString().replace('.', ',')
        },
        ob1RatingStyle() {
            return '--rating-results-height: ' + this.ratingResultsHeight + 'rem;'
        }
    }
}
</script>
